import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-withdrawal-receipt',
  templateUrl: './withdrawal-receipt.page.html',
  styleUrls: ['./withdrawal-receipt.page.scss'],
})
export class WithdrawalReceiptPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
